// Basic
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
// Store & actions
import useRootOrganizationStore from '../../../../store/rootOrganization';
import useContractStore from '@/app/store/modules/contract';
import actionsContracts from '../../api/actionsContracts';
// Components
import DataTable from '../../../../../common-utils/components/renders/dataTable/DataTable';
// Common
import { columnsTerminalContract, columnsTerminalContractId } from './columnDef/columnsTerminalContract';
import getInitialQuery from '@/common-utils/components/renders/dataTable/utils/getInitialQuery';
import mergeQuery from '@/common-utils/components/renders/dataTable/utils/mergeQuery';

/**
 *
 * @param root0
 * @param root0.posTerminalId
 * @param root0.filtersEventName
 * @returns {JSX} TerminalContractsTable
 */
function TerminalContractsTable({ posTerminalId, filtersEventName }) {
    // Store
    const rootOrganization = useRootOrganizationStore(s => s.rootOrganization);
    const { refetchContracts: refetchFromStore, storeRefetchContracts, query: queryStored, storeQuery } = useContractStore();

    // Constants
    const initialQuery = getInitialQuery();

    // State
    const [query, setQuery] = useState(mergeQuery(initialQuery, queryStored));
    const [launchRefetch, setLaunchRefetch] = useState(true);

    // Api Calls
    const { data, isFetching, refetch } = actionsContracts.getTerminalContracts({ query: query, posTerminalId: posTerminalId }, false);

    // Hooks
    useEffect(() => {
        if (rootOrganization && (launchRefetch || refetchFromStore)) {
            refetch();
            setLaunchRefetch(false);
            storeRefetchContracts(false);
        }
    }, [query, launchRefetch, refetchFromStore]);

    const allColumns = columnsTerminalContract({ query, setQuery, queryStored, storeQuery, setLaunchRefetch, filtersEventName });

    // Render
    return (
        <DataTable
            filtersEventName={filtersEventName}
            columns={allColumns}
            data={data}
            dataFetchingIsLoading={isFetching}
            columnsId={columnsTerminalContractId}
            initialQuery={initialQuery}
            query={query}
            setQuery={setQuery}
            queryStored={queryStored}
            storeQuery={storeQuery}
            setLaunchRefetch={setLaunchRefetch}
        />
    );
}

TerminalContractsTable.propTypes = {
    posTerminalId: PropTypes.string.isRequired,
    filtersEventName: PropTypes.string
};

export default TerminalContractsTable;